import axios from './../plugins/private-api-axios'

export const reportService = {
    urlPrefix: '/reports',
    config: {
        headers: {
            Authorization: ''
        }
    },
    async getOverSpeedReport (fleetId, vehicleId, dateFrom, dateTo) {
        let urlBuilder = {
            dateFrom: dateFrom,
            dateTo: dateTo
        }

        if (null !== fleetId) {
            urlBuilder['VehicleFleetId'] = fleetId
        }

        if (null !== vehicleId) {
            urlBuilder['VehicleId'] = vehicleId
        }

        try {
            return await axios.get(`${this.urlPrefix}/getOverSpeedReport?${new URLSearchParams(urlBuilder).toString()}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async getJourneysReport (fleetId, vehicleId, dateFrom, dateTo) {
        let urlBuilder = {
            dateFrom: dateFrom,
            dateTo: dateTo
        }

        if (null !== fleetId) {
            urlBuilder['VehicleFleetId'] = fleetId
        }

        if (null !== vehicleId) {
            urlBuilder['VehicleId'] = vehicleId
        }

        try {
            return await axios.get(`${this.urlPrefix}/getJourneysReport?${new URLSearchParams(urlBuilder).toString()}`, this.config)
        } catch (e) {
            throw e
        }
    },
    async getEventsReport (fleetId, vehicleId, dateFrom, dateTo) {
        let urlBuilder = {
            dateFrom: dateFrom,
            dateTo: dateTo
        }

        if (null !== fleetId) {
            urlBuilder['VehicleFleetId'] = fleetId
        }

        if (null !== vehicleId) {
            urlBuilder['VehicleId'] = vehicleId
        }

        try {
            return await axios.get(`${this.urlPrefix}/getEventsReport?${new URLSearchParams(urlBuilder).toString()}`, this.config)
        } catch (e) {
            throw e
        }
    }
}

export const updateReportService = (accessToken) => {
    reportService.config.headers.Authorization = accessToken
}

export default reportService
